import testConfig from './system.test.config'
import devConfig from './system.dev.config'
import prodConfig from './system.prod.config'
import NODE_ENV from '../NodeEnvType'

let config
switch (process.env.VUE_APP_NODE_ENV) {
  case NODE_ENV.TEST: //测试环境
    config = testConfig
    break
  case NODE_ENV.DEV: //开发环境
    config = devConfig
    break
  case NODE_ENV.PROD: //生产环境
    config = prodConfig
    break
  default:
    config = devConfig
    break
}
export default config
